export const CALENDLY_URL =
  "https://calendly.com/professorkez/school-at-night-candidate-interviews";

// MailerLite — paste the form ID from your embed snippet here.
// Find it: MailerLite → Sites → Forms → pick form → Embed → copy data-form="..."
// Leave as REPLACE_WITH_MAILERLITE_FORM_ID to show a friendly setup placeholder.
export const MAILERLITE_FORM_ID = "REPLACE_WITH_MAILERLITE_FORM_ID";

export const LOGO_URL = "/img/skillhouseu-logo.png";

export const FOUNDER_IMG = "/img/professor-kez.jpg";

export const TESTIMONIAL_IMGS = [
  "https://images.unsplash.com/photo-1507152832244-10d45c7eda57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdvbWFuJTIwZW50cmVwcmVuZXVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc5ODM0NzQzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/5934188/pexels-photo-5934188.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/8547396/pexels-photo-8547396.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const LIFESTYLE_IMGS = [
  "https://images.unsplash.com/photo-1765648496319-1a645c914171?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdvbWVuJTIwd29ya2luZyUyMGxhcHRvcCUyMGNhZmV8ZW58MHx8fHwxNzc5ODM0NzQzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/30690399/pexels-photo-30690399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const COURSES = [
  {
    id: "agent",
    title: "AI Agent Building Certification",
    duration: "6-Hour Intensive",
    price: "$199",
    desc:
      "Build autonomous agents that run the boring parts of your business while you sleep. Walk out certified.",
    badge: "Most Popular",
  },
  {
    id: "animation",
    title: "AI Animation Course",
    duration: "4-Hour Masterclass",
    price: "$149.99",
    desc:
      "Turn flat brand assets into scroll-stopping motion. Made for the founder who already gets the algorithm.",
    badge: "New Drop",
  },
  {
    id: "coding",
    title: "AI Coding Course",
    duration: "2-Hour Crash",
    price: "$99",
    desc:
      "No CS degree? Don't need one. Prompt your way to a working MVP before Sunday brunch.",
    badge: "Beginner Safe",
  },
];

export const TESTIMONIALS = [
  {
    name: "Tasha M.",
    city: "Atlanta, GA",
    role: "Founder, Tasha & Co. Skincare",
    image:
      "https://images.unsplash.com/photo-1507152832244-10d45c7eda57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdvbWFuJTIwZW50cmVwcmVuZXVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc5ODM0NzQzfDA&ixlib=rb-4.1.0&q=85",
    quote:
      "Sis. I built a customer service agent in one weekend and it handles 80% of my DMs. I got my Saturdays back.",
  },
  {
    name: "Imani R.",
    city: "Houston, TX",
    role: "Creative Director, Big Idea Studio",
    image:
      "https://images.pexels.com/photos/5934188/pexels-photo-5934188.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "Professor Kez does NOT play. The animation course paid for itself before I even finished module 3. My reels eating now.",
  },
  {
    name: "Dr. Yvonne A.",
    city: "Brooklyn, NY",
    role: "Solopreneur & Coach",
    image:
      "https://images.pexels.com/photos/8547396/pexels-photo-8547396.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "I came in skeptical, left certified. This wasn't another fluff webinar — this is the playbook our community needed.",
  },
];

export const SOCIALS = [
  { label: "Instagram", handle: "@keziamw", href: "https://instagram.com/keziamw" },
  { label: "TikTok", handle: "@keziamw", href: "https://tiktok.com/@keziamw" },
  { label: "YouTube", handle: "@keziamw", href: "https://youtube.com/@keziamw" },
];
